import { MenuItem, Select } from "@mui/material";
import { Controller, ControllerType } from "../Model/controller";
import { controlleStore } from "../Stores/controllerStore";
import { CSSProperties, useEffect, useState } from "react";

const ControllerSelect: React.FC<{
  onSelected: (value: Controller) => void;
  cType: ControllerType;
}> = ({ onSelected, cType }) => {
  const [option, setOption] = useState<string>("");
  const [filtered, setFiltered] = useState<Controller[]>(
    controlleStore.collection
  );
  const itemStyle = {
    display: "flex",
    flexFlow: "row",
  } as CSSProperties;

  useEffect(() => {}, [cType]);
  return (
    <Select
      labelId="demo-simple-select-filled-label"
      id="demo-simple-select-filled"
      value={option}
      onChange={(e) => {
        setOption(e.target.value as string);
      }}
    >
      {filtered.map((cm) => (
        <MenuItem value={cm.id} style={itemStyle}>
          <label>{cm.nickname}</label>
        </MenuItem>
      ))}
    </Select>
  );
};

export { ControllerSelect };
